"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartEditReady = exports.SmartEditApply = exports.SmartEditRun = exports.SMART_EDIT_READY = exports.SMART_EDIT_APPLY = exports.SMART_EDIT_COMPLETE = void 0;
/**
 * @ReduxAction Smart Edit has been completed
 */
exports.SMART_EDIT_COMPLETE = 'SMART_EDIT_COMPLETE';
/**
 * @ReduxAction Smart Editis being applied
 */
exports.SMART_EDIT_APPLY = 'SMART_EDIT_APPLY';
/**
 * @ReduxAction SmartEdit Module is ready
 */
exports.SMART_EDIT_READY = 'SMART_EDIT_READY';
const SmartEditRun = (bypassValidationWarnings) => ({
    type: exports.SMART_EDIT_COMPLETE,
    bypassValidationWarnings: bypassValidationWarnings,
});
exports.SmartEditRun = SmartEditRun;
const SmartEditApply = (cellUpdateRequests) => ({
    type: exports.SMART_EDIT_APPLY,
    cellUpdateRequests,
});
exports.SmartEditApply = SmartEditApply;
const SmartEditReady = () => ({
    type: exports.SMART_EDIT_READY,
});
exports.SmartEditReady = SmartEditReady;
